(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const flyToCart = (sourceEl) => {
    const cartIcon = document.querySelector('[data-cart-icon]');
    if (!cartIcon || !sourceEl) return;

    const startRect = sourceEl.getBoundingClientRect();
    const endRect = cartIcon.getBoundingClientRect();
    if (!startRect.width || !startRect.height) return;

    if (reduced()) {
      cartIcon.classList.add('is-bumping');
      setTimeout(() => cartIcon.classList.remove('is-bumping'), 400);
      return;
    }

    const clone = sourceEl.cloneNode(true);
    clone.removeAttribute('id');
    Object.assign(clone.style, {
      position: 'fixed',
      zIndex: '9999',
      left: `${startRect.left}px`,
      top: `${startRect.top}px`,
      width: `${startRect.width}px`,
      height: `${startRect.height}px`,
      margin: '0',
      borderRadius: '10px',
      objectFit: 'cover',
      pointerEvents: 'none',
      opacity: '1',
      transition: 'transform 0.7s cubic-bezier(0.35, 0, 0.25, 1), opacity 0.7s ease 0.15s',
      willChange: 'transform, opacity',
    });
    document.body.appendChild(clone);

    const dx = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    const dy = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        clone.style.transform = `translate(${dx}px, ${dy}px) scale(0.12)`;
        clone.style.opacity = '0.25';
      });
    });

    const cleanup = () => {
      clone.remove();
      cartIcon.classList.add('is-bumping');
      setTimeout(() => cartIcon.classList.remove('is-bumping'), 400);
    };
    clone.addEventListener('transitionend', cleanup, { once: true });
    setTimeout(cleanup, 950);
  };

  document.addEventListener('cart:fly', (e) => {
    flyToCart(e.detail && e.detail.sourceEl);
  });
})();
